jQuery(document).ready(function($) {

  if ( $('.m-podcast-cta')[0] ) {
    $('.m-podcast-cta').on('expand', function() {
      $(this).addClass('m-podcast-cta--open');
      $(this).find('.m-podcast-cta__link:first-child').focus();
    });

    $('.m-podcast-cta').on('unexpand', function() {
      $(this).removeClass('m-podcast-cta--open');
    });

    $('.m-podcast-cta__button').click(function() {
      $(this).closest('.m-podcast-cta').trigger('expand');
    });

    $('.m-podcast-cta__link').keydown(function(e) {
      const $cta    = $(this).closest('.m-podcast-cta');
      const $button = $cta.find('.m-podcast-cta__button');

      switch (e.key) {
        case "Escape":
        case "Esc":
          $cta.trigger('unexpand');

          setTimeout(function() {
            $button.focus();
          }, 250);
          break;
      }
    });

    $('.m-podcast-cta__link').blur(function(e) {
      const newTarget = e.relatedTarget;

      if (
        newTarget === null
        || !newTarget.classList.contains("m-podcast-cta__link")
        || e.target.offsetParent != newTarget.parentElement
      ) {
        $(this).closest('.m-podcast-cta').trigger('unexpand');
      }
    });
  }

});